import { PropsWithChildren, ReactElement } from "react";
import { FontIconValueWithColor, Icon } from "client/Components";
import styles from "./HubSidebarItemContent.module.less";
import { setTrackingId } from "client/Misc/utils";

export type HubSidebarItemContentProps = {
	icon?: FontIconValueWithColor;
	trackingId: string;
};

export const HubSidebarItemContent = (props: PropsWithChildren<HubSidebarItemContentProps>): ReactElement => {
	const {
		icon,
		children,
		trackingId
	} = props;

	return (
		<div {...setTrackingId(trackingId)} className={styles.root}>
			{icon && (
				<Icon
					value={icon}
				/>
			)}
			<div {...setTrackingId("text")} className={styles.content}>
				{children}
			</div>
		</div>
	);
};
HubSidebarItemContent.displayName = "HubSidebarItemContent";